import { useState } from "react";
import ReasonDialog from "./ReasonDialog";
import { Box, Link, TextField } from "@mui/material";

const BreakMinutes = ({ reason, onReasonChange, ...props }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
      }}
    >
      <TextField {...props} />
      <Link
        sx={{ marginLeft: "8px" }}
        onClick={() => {
          setDialogOpen(true);
        }}
      >
        Reason
      </Link>
      <ReasonDialog
        disabled={props.disabled}
        title="Break Reason"
        value={reason}
        open={dialogOpen}
        handleClose={() => {
          setDialogOpen(false);
        }}
        onSubmit={(newReason) => {
          onReasonChange(newReason);
          setDialogOpen(false);
        }}
      />
    </Box>
  );
};

export default BreakMinutes;
